import CheckboxFacetController from './checkbox-facet.controller';
import { CheckboxFacetProps } from './checkbox-facet.model';

const CheckboxFacet: React.FC<CheckboxFacetProps> = (props) => {
  return <CheckboxFacetController {...props} />;
};

export default CheckboxFacet;
